import './App.css';
import {
  useNavigate
} from "react-router-dom";
import { useEffect, useState } from 'react';
import Input from './components/inputcomp.js';
import logo from './images/logo.jpg'
import bg from './images/bg.png'
import woman from './images/woman.png'
import wtm from './images/wtm.webp'
import axios from 'axios';


export default function Home() {
  const[details, setdetails] = useState({
    name:'',
    email:'',
    area:'',
    proficiency:''
  });
  const[rsvp, setrsvp] = useState(false)
  const org = [
    {
      id:1,
      img:'./iwd (1).jpg',
      name:'Motunrayo Jacob',
      port:'WTM Ambassador, Organizer',
    },
  ]
  const speak = [
    {
      id:3,
      img:'./iwd.jpg',
      name:'Zainab Alayande',
      port:'Software Engineer',
    },
  ]
  useEffect(()=>{
      checks()
    },[])
  const[showe, setshowe] = useState(false);  
  const[error, seterror] = useState({});  
  const[msg, setmsg] = useState('');  
  const[count, setcount] = useState(52);  

  var format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  var formatem = /[ `!#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/;

  const nav = useNavigate()
  const checker = async(e) => {
    e.preventDefault();
    console.log(Object.values(details).every(x => !!x))
    if(Object.values(details).every(x => !!x)===false){
      seterror({...error, submit:'Kindly complete all the fields correctly'})
    }
    else{
      console.log('fire submission')
      console.log(details)
      seterror(current => {
        const {submit, ...rest} = current;
        return rest;
      });
      try {
        const response = await axios.post('/api/', details);
        console.log(response.data)
        setmsg(response.data.msg)
        setdetails({...details,
          name:'',
          email:'',
          area:'',
          proficiency:''

        })
        setTimeout(() => {
            setmsg('')
            window.location.reload(false);
        }, 2000);
        
    } catch (error) {
        console.log(error.response.data)
    }
    }
  }
  const showextra = (val)=>{
    if (val === '0') {
      setshowe(true)
    }
    else{
      console.log('added')
      setshowe(false)
      setdetails({...details, area:val})
    }
  }
  const checks = async() => {
    try {
        const response = await axios.get('/api/');
        console.log(response.data)
        setcount(response.data.length)
    }
    catch (error) {
        console.log(error.response.data)
    }
  }
  
  return (
    <div className="container">
      
      <div className='topbar'>
          <img src={bg} alt='dare'/>
      </div>
      <div className='form'>
        <div className='formtop'>
        <div className='floater'>
          <img src={bg} alt='dare'/>
        </div>
          <h1>WTM Ikotun International Women’s Day 2025</h1>
          {/* <div className='img'>
            <img src={wtm} alt='dare'/>
          </div> */}
          <h3>About this event</h3>
          <div className='statement'>
            <p>Join us on a three day event as we celebrate the power of women and empower girls in technology. Our event, "Redefine Possible," aims to inspire and empower young girls in secondary schools to pursue careers in tech. Through interactive workshops and training sessions, we'll introduce them to exciting topics like artificial intelligence (AI) and more.</p>
          </div>
          {/* <div className='type'>In-person event</div> */}
          <div className='date'>Date: 24th - 26th March, 2025</div>
          <div className='date'>Venue: Great Carson schools , Isheri Lagos</div>
          <div className='date'>Time: 11:00 am</div>
        </div>

        <div className='acts'>
          <h2>Activities</h2>
          <div className='p'>
            <p>Meet and greet</p>
            <p>Exhibition</p>
            <p>Workshop</p>
            <p>Speaker Session</p>
            <p>Swags and more...</p>
          </div>
        </div>

        <p className='rsvpd'>{count+56} persons RSVP'd</p>
        {
          Object.values(error).length >= 1 ?
          <div className='errors'>
          {
              Object.values(error).map((a, i)=>(
                  <p>{a}</p>
              ))
          }
          </div>
          :
          msg ?
          <div className='success'>
            {msg}
          </div>
          :
          ''
        }
        {
          rsvp === true ?
          <form>
          <div>
            <p>Full name *</p>
            <input onChange={(e)=>{
                if(format.test(e.target.value) === false){
                  setdetails({...details, name:e.target.value})
                  seterror(current => {
                    const {name, submit, ...rest} = current;
                    return rest;
                  });
                }
                else{
                  seterror({...error, name:'Kindly provide a valid name'})
                }
                
              }} 
              type="text" 
              value={details.name}
              placeholder="Full name"/>
          </div>
          <div>
            <p>Email *</p>
            <input onChange={(e)=>{
              if(formatem.test(e.target.value) === false){
                setdetails({...details, email:e.target.value})
                seterror(current => {
                  const {email:value, ...rest} = current;
                  return rest;
                });
              }else{
                seterror({...error, email:'Kindly provide a valid email address'})
              }
            
            }} 
            type="text" 
            value={details.email}
            placeholder="Email"/>
          </div>
          <div>
            <p>Area of interest *</p>
          <select onChange={(e)=>showextra(e.target.value)}>
              <option value=''>Area of interest</option>
              <option value='Design'>Design</option>
              <option value='Web'>Web</option>
              <option value='Data Analytics'>Data Analytics</option>
              <option value='0'>Others</option>
          </select>
          {
            showe === true ?
            <input  type="text" onChange={(e)=>setdetails({...details, area:e.target.value})} placeholder="Name of area"/>
            :''
          }</div>
          <div>
            <p>Proficiency level *</p>
            <select onChange={(e)=>setdetails({...details, proficiency:e.target.value})}>
                <option>Proficiency level</option>
                <option>Beginner</option>
                <option>Intermediate</option>
                <option>Expert</option>
            </select>
          </div><input onClick={checker} type="submit" />
        </form>
        :
        <div className='rsvp' onClick={(e)=>setrsvp(!rsvp)}>RSVP</div>
        
        }
        

        <div className='formtop'>
          <h3>Organizer</h3>
          <div className='speakers'>
            {
              org.map(({id, img, name, port})=>(
                <div className='wrap'>
                  <div className='img'>
                    <img src={img} alt='dare'/>
                  </div>
                  <h4>{name}</h4>
                  <p>{port}</p>
                </div>
              ))
            }
          </div>
          <h3>Speakers</h3>
          <div className='speakers'>
            {
              speak.map(({id, img, name, port})=>(
                <div className='wrap'>
                  <div className='img'>
                    <img src={img} alt='dare'/>
                  </div>
                  <h4>{name}</h4>
                    <p>{port}</p>
                </div>
              ))
            }
          </div>
          
        </div>
        <div className='footer'>&copy; 2025 All Rights reserved</div>
        </div>
      
    </div>
  );
}

// export default App;
